module.exports = __webpack_public_path__ + "img/Devika-Krishna.12256ded.jpg";